import { Box, Button, Divider, Flex, FormControl, FormLabel, HStack, IconButton, Select, Stack, Text, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { Link as DefaultLink, useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { companyCustomerType, deliveryType, fleetType } from '../../types';
import { fetchCustomers, fetchDeliveries, updateDelivery } from '../../store/actions';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { FiArrowLeft } from 'react-icons/fi';
import { ToastContainer } from 'react-toastify';
import { addDeliveryFormValidation } from '../../utils';
import { fetchFleets } from '../../store/actions/fleet-actions';
import { useFormik } from 'formik';

export const EditDelivery = () => {

    const [customer, setCustomer] = useState<any>({});
    const [fleet, setFleet] = useState<any>({});
    const [delivery, setDelivery] = useState<deliveryType>({});

    const [_loaders] = useState<Array<number>>([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);

    //eslint-disable-next-line
    const [distance, setDistance] = useState<string | any>(null || delivery?.distance);

    const { fleets } = useAppSelector(state => state.fleetReducer);

    const { customers } = useAppSelector(state => state.customersReducer);
    const { company } = useAppSelector(state => state.companyReducer);

    const { is_updating_delivery, deliveries } = useAppSelector(state => state.deliveryReducer);

    const { settings } = company ?? {};
    const  { payment } = settings ?? {};

    const dispatch: AppDispatch = useAppDispatch();

    const navigate = useNavigate();

    const { delivery_id } = useParams();


    const deliveryForm = useFormik({
        initialValues: {
            customer_id: '',
            fleet: '',
            payment_method: '',
            loaders: '',
            loaders_amount: '',
            total: '',
        },
        validationSchema: addDeliveryFormValidation,
        validateOnBlur: true,
        onSubmit: (values: deliveryType) => {

            const _customer = {
                customer_id: customer?.customer_id,
                customer_name: `${customer?.first_name} ${customer?.last_name}`,
            };

            const newValues: any = { ...delivery, ...values, ..._customer, loaders_amount, total: Number(total).toFixed(2), fleet_amount: Number(fleet?.fleet_amount).toFixed(2), status: 'await approval', distance, distance_amount: (Number(delivery?.distance) * Number(fleet?.per_km)).toFixed(2), vat: (sub_total*0.15).toFixed(2) };
            dispatch(updateDelivery(newValues)).then(() => navigate('/deliveries'));
            // alert(JSON.stringify(newValues, null, 2));
        }
    });

    const loaders_amount = (Number(deliveryForm.values.loaders || delivery?.loaders) * (fleet?.loader_amount || delivery?.loaders_amount)) || 0;
    const sub_total = (fleet?.fleet_amount || delivery?.fleet_amount) + (fleet?.per_km * Number(distance?.split(' ')[0] || delivery?.distance)) + (Number(deliveryForm.values.loaders || delivery?.loaders) * (fleet?.loader_amount));
    const total = (sub_total + (payment?.vat ? ((sub_total * 0.15) || delivery?.vat) : 0)) || delivery?.total;

    const setDeliveryValues = async () => {

        const [delivery] = await deliveries?.filter((delivery: deliveryType) => delivery?.delivery_id === delivery_id);
        setDelivery(delivery);

        deliveryForm.setFieldValue('customer_id', delivery?.customer_id);
        deliveryForm.setFieldValue('fleet', delivery?.fleet);
        deliveryForm.setFieldValue('payment_method', delivery?.payment_method);
        deliveryForm.setFieldValue('total', delivery?.total);
        deliveryForm.setFieldValue('loaders', delivery?.loaders);

    };

    useEffect(() => {
        const selectedFleet = fleets?.filter((fleet: fleetType) => fleet.fleet_size === deliveryForm.values.fleet)[0];
        setFleet(selectedFleet);
    }, [deliveryForm.values.fleet]);

    useEffect(() => {
        const selectedCustomer = customers?.filter((customer: companyCustomerType) => customer.customer_id === deliveryForm.values.customer_id)[0];
        setCustomer(selectedCustomer);
    }, [deliveryForm.values.customer_id]);

    useEffect(() => {
        dispatch(fetchDeliveries()).then(() => setDeliveryValues());
        dispatch(fetchFleets());
        dispatch(fetchCustomers());
        return () => {
            setDeliveryValues();
        };
    }, []);

    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            py={10}
        >
            <Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}>
                    <Stack spacing={4}>
                        <HStack align={'center'}>
                            <Stack>
                                <IconButton variant={'ghost'} aria-label='go back' icon={<FiArrowLeft style={{ width: '24px', height: '24px' }} />} as={DefaultLink} to='/deliveries' />
                            </Stack>
                            <Stack>
                                <Text display={'flex'} fontSize={'lg'} fontWeight='medium' textAlign={'center'}>
                                    Edit delivery.
                                </Text>
                            </Stack>
                        </HStack>
                        <Divider />
                        <Stack mb={3}>
                            <Text textAlign={'center'} fontSize={'lg'} color={'gray.600'}>
                                To enjoy all of our cool features ✌️
                            </Text>
                        </Stack>
                        <form onSubmit={deliveryForm.handleSubmit}>
                            <FormControl id="customer" isRequired mb={deliveryForm.errors.customer_name ? 0 : 5}>
                                <HStack justifyContent={'space-between'}>
                                    <FormLabel>Customer</FormLabel>
                                    <Tooltip label='Add customer' fontSize='md'>
                                        <Button size={'xs'} colorScheme={'yellow'} fontWeight={'bold'} onClick={() => navigate('/customers/add')}>+</Button>
                                    </Tooltip>
                                </HStack>
                                <Select style={{ textTransform: 'capitalize' }} name='customer_id' value={deliveryForm.values.customer_id} onChange={deliveryForm.handleChange} onBlur={deliveryForm.handleBlur} placeholder='Select customer'>
                                    {
                                        customers && customers.map((customer: companyCustomerType, index: number) => (
                                            <option key={index} style={{ textTransform: 'capitalize' }} value={`${customer.customer_id}`} >{customer.first_name} {customer.last_name}</option>
                                        ))
                                    }
                                </Select>
                                {!customer && <Text fontSize='sm' color='red.400'>Select a customer</Text>}
                            </FormControl>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="fleet" isRequired mb={deliveryForm.errors.fleet ? 0 : 5}>
                                        <HStack justifyContent={'space-between'}>
                                            <FormLabel>Fleet size</FormLabel>
                                            <Tooltip label='Add fleet' fontSize='md'>
                                                <Button size={'xs'} colorScheme={'yellow'} fontWeight={'bold'} onClick={() => navigate('/vehicles/fleets/add')}>+</Button>
                                            </Tooltip>
                                        </HStack>
                                        <Select name='fleet' placeholder='Select fleet' value={deliveryForm.values.fleet} onChange={deliveryForm.handleChange} onBlur={deliveryForm.handleBlur}>
                                            {
                                                fleets && fleets.map((fleet: fleetType, index: number) => (
                                                    <option key={index} value={`${fleet.fleet_size}`}>{fleet.fleet_size}</option>
                                                ))
                                            }
                                        </Select>
                                        {deliveryForm.errors.fleet && <Text fontSize='sm' color='red.400'>{deliveryForm.errors.fleet}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="loaders" isRequired mb={deliveryForm.errors.payment_method ? 0 : 5}>
                                        <FormLabel>Number of loaders</FormLabel>
                                        <Select name='loaders' placeholder='Select loaders' value={Number(deliveryForm.values.loaders)} onChange={deliveryForm.handleChange} onBlur={deliveryForm.handleBlur} disabled={!fleet}>
                                            {
                                                _loaders?.map((loader: number, index: number) => <option key={index} value={loader}>{loader} - R{loader * fleet?.loader_amount}</option>)
                                            }
                                        </Select>
                                        {deliveryForm.errors.payment_method && <Text fontSize='sm' color='red.400'>{deliveryForm.errors.payment_method}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="payment_method" isRequired mb={deliveryForm.errors.payment_method ? 0 : 5}>
                                        <FormLabel>Payment method</FormLabel>
                                        <Select name='payment_method' placeholder='Select method' value={deliveryForm.values.payment_method} onChange={deliveryForm.handleChange} onBlur={deliveryForm.handleBlur}>
                                            <option value='cash'>Cash</option>
                                            <option value='card'>Card</option>
                                            <option value='eft'>EFT</option>
                                        </Select>
                                        {deliveryForm.errors.payment_method && <Text fontSize='sm' color='red.400'>{deliveryForm.errors.payment_method}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <Stack bg={'#f5f5f5'} p={3} borderRadius={6} mb={3}>
                                <Text>Fleet Amount: {`R ${Number(fleet?.fleet_amount).toFixed(2) || 0}`}</Text>
                                <Text>Distance: {distance || delivery?.distance} km * R{Number(fleet?.per_km).toFixed(2) || 0} p/k = {`R ${(Number(delivery?.distance) * Number(fleet?.per_km)).toFixed(2) || 0.00}`}</Text>
                                <Text style={{ marginTop: '0rem !important' }}>Loaders: {deliveryForm.values.loaders || delivery?.loaders} x R{fleet?.loader_amount || 0} =  R{(Number(deliveryForm.values.loaders || delivery?.loaders) * fleet?.loader_amount) || 0}</Text>
                                <p>Vat (15%): R{payment?.vat ? ((sub_total*0.15).toFixed(2) || delivery?.vat) : 0}</p>
                                <Text fontWeight={'bold'}>Total: R{Number(total || delivery?.total).toFixed(2)}</Text>
                            </Stack>
                            <Stack spacing={10} pt={2}>
                                <Button
                                    type='submit'
                                    isLoading={is_updating_delivery}
                                    disabled={!customer || is_updating_delivery}
                                    loadingText="Submitting"
                                    size="lg"
                                    colorScheme={'yellow'}
                                >
                                    Submit
                                </Button>
                            </Stack>
                        </form>
                    </Stack>
                </Box>
            </Stack>
            <ToastContainer />
        </Flex>
    );
};